/* eslint-disable import/no-unresolved */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
// import CategoryToolTip from '../../../../Components/CategoryToolTip';
// import ThreeDotsLoader from '../../../../Components/LoadingDots';
import CategoryToolTip from '../../../../Components/CategoryToolTip';
import ThreeDotsLoader from '../../../../Components/LoadingDots';
import { ExpectedDateGenerator } from '../../../../redux/helper/DateConverter';

// for ES6 modules
function AddressChangeModal({
    addressPopup, setaddressPopup, prod, OrderDetails, setOrderDetails, addressDropdown, GroupCategory, setaddresmodal, handleUpdateAddress,
}) {
    const [isOn, setIsOn] = useState(false);
    const [searchKey, setsearchKey] = useState('');
    const [loading, setloading] = useState(false);
    const [addressType, setaddressType] = useState({
        shipping_address: false,
        billing_address: false,
    });
    const [tempData, settempData] = useState(prod);
    const handleClose = () => {
        setaddressType({
            shipping_address: false,
            billing_address: false,
        });
    };
    const handleToggle = (key) => {
        setsearchKey('');
        handleClose();
        setaddressType((prev) => ({
            ...prev,
            [key]: !addressType[key],

        }));
    };

    const toggleSwitch = () => {
        setIsOn(!isOn);
    };

    const [hoverId, sethoverId] = useState('');
    const handleAddressSelect = (item, key) => {
        handleClose();
        settempData((prev) => ({
            ...prev,
            [key]: item,
        }));
    };
    const handleConfirm = () => {
        setloading(true);
        const payload = {
            category: GroupCategory,
            item_id: tempData.item_id,
            default: isOn,
        };
        payload.shipping_address = tempData.SHIPPING_ADDRESS;
        payload.billing_address = tempData.BILLING_ADDRESS;
        handleUpdateAddress(payload, OrderDetails.distributor_id, OrderDetails.order_number).then((res) => {
            setloading(false);
            setaddressPopup(false);
            setaddresmodal('');
        });
    };
    const handleSearch = (val) => {
        if (searchKey === '') {
            return val;
        } if (val.ADDRESS1?.toLowerCase().includes(searchKey.toLowerCase())
        || val.ADDRESS2?.toLowerCase().includes(searchKey.toLowerCase())
        || val.ADDRESS3?.toLowerCase().includes(searchKey.toLowerCase())
        || val.ADDRESS4?.toLowerCase().includes(searchKey.toLowerCase())
        || val.POSTAL_CODE?.toLowerCase().includes(searchKey.toLowerCase())
        || val.LOCATION?.toLowerCase().includes(searchKey.toLowerCase())) {
            return val;
        }
    };
    const handleCheck = (add, type) => tempData[type].ADDRESS1 === add.ADDRESS1 && tempData[type].ADDRESS2 === add.ADDRESS2 && tempData[type].ADDRESS3 === add.ADDRESS3 && tempData[type].POSTAL_CODE === add.POSTAL_CODE && tempData[type].LOCATION === add.LOCATION;
    return (
        <div className="modal-dialog modal-dialog-centered relative lg:min-w-[761px] px-3 mx-auto pointer-events-none">
            <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white bg-clip-padding rounded-md outline-none text-current md:px-[32px] sm:px-5 px-3.5 sm:pt-[32px] pt-5 sm:pb-6 pb-5">
                <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                    <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                        Change Address
                    </h5>
                    <button
                        onClick={() => {
                            setaddresmodal('');
                            setaddressPopup(false);
                        }}
                        type="button"
                        className="absolute top-0 right-0"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    >
                        <img src="/images/Icon-ionic-ios-close.svg" alt="" />
                    </button>
                </div>
                <div className="modal-body relative sm:pt-7 pt-3">
                    <div className="rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-5 pt-4 relative w-full">
                        <div className="flex flex-wrap">
                            <div className="lg:w-[80%] w-full pt-2">
                                <div className="flex">
                                    <div>
                                        <div className="flex sm:items-center items-start sm:flex-row flex-col">
                                            <p className="sm:text-xl text-base font-bold text-[#090406] pr-3">{prod?.MODEL_DESCRIPTION || `${prod?.DESCRIPTION.length > 20 ? `${prod.DESCRIPTION.slice(0, 20)}...` : `${prod.DESCRIPTION}`}`}</p>
                                            <p className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit sm:mt-0 mt-1">{prod?.MAIN_CATEGORY}</p>
                                        </div>
                                        <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1">
                                            <span>
                                                Product Code:
                                                {' '}
                                                {prod?.CONCATENATED_SEGMENTS}
                                            </span>
                                            <span className="sm:px-4 px-2">|</span>
                                            <span>
                                                AWS Classification:
                                                {' '}
                                                {prod?.AWS_CLASSIFICATION}
                                            </span>
                                        </p>
                                        <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                            <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                                <p className="text-xs font-semibold text-[090406]">Category</p>
                                                <p className="text-xs3 font-semibold text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">A</p>
                                                <button
                                                    onMouseEnter={() => {
                                                        setTimeout(() => {
                                                            sethoverId(prod.INVENTORY_ITEM_ID);
                                                        }, 1000);
                                                    }}
                                                    onMouseLeave={() => {
                                                        setTimeout(() => {
                                                            sethoverId('');
                                                        }, 2000);
                                                    }}
                                                    data-tooltip-target="tooltip-information"
                                                    data-tooltip-placement="left"
                                                    data-tooltip-trigger="click"
                                                    type="button"
                                                >
                                                    <img src="/images/info_icon.svg" alt="icon" className="cursor-pointer" />
                                                </button>
                                                {hoverId === prod.INVENTORY_ITEM_ID && (
                                                    <CategoryToolTip hover={hoverId === prod.INVENTORY_ITEM_ID} />
                                                )}
                                            </div>
                                            <p className="text-xs3 font-semibold text-[#808285] sm:px-[6px] sm:border-r sm:border-[#707070] sm:pt-0 pt-1">
                                                Expected Dispatch:
                                                {' '}
                                                <span className="font-bold text-[#555259]">{prod.DELIVERY_LEAD_TIME ? ExpectedDateGenerator(prod?.DELIVERY_LEAD_TIME) : '-'}</span>
                                            </p>
                                            <p className="text-xs3 font-semibold text-[#808285] sm:pl-[6px] sm:pt-0 pt-1">
                                                Method of Packing:
                                                {' '}
                                                <span className="font-bold text-[#555259]">{prod?.METHOD_OF_PACKING}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full pb-2 pt-2.5 rounded-lg flex flex-wrap justify-start xl:mr-4">
                            <div className="pr-2 border-r border-[#CECECE] xl:w-auto sm:w-1/3 w-1/2">
                                <p className="text-xs font-semibold text-[#808285]">Standard Pack Size</p>
                                <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                    {prod?.PACKING_SIZE}
                                    {' '}
                                    {prod?.PRIMARY_UOM_CODE}

                                </p>
                            </div>
                            <div className="px-2 sm:border-r border-[#CECECE] xl:w-auto sm:w-1/3 w-1/2">
                                <p className="text-xs font-semibold text-[#808285]">Size</p>
                                <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                    {`${prod.DIAMETER !== null ? `${prod.DIAMETER}mm` : ''}`}
                                    {`${prod.LENGTH !== null && prod.DIAMETER ? 'x' : ''}`}
                                    {`${prod.LENGTH !== null ? `${prod.LENGTH}mm` : ''}`}
                                    {prod.LENGTH === null && prod.DIAMETER === null ? '-' : ''}
                                </p>
                            </div>
                            <div className="sm:pl-2 pt-2 sm:pt-0">
                                <p className="text-xs font-semibold text-[#808285]">Quantity</p>
                                <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{prod?.MINIMUM_ORDER_QUANTITY || 1}</p>
                            </div>
                        </div>
                        <div className="flex justify-center items-end flex-col">
                            <div className="flex justify-end pt-3">
                                <label>
                                    <Toggle
                                        checked={isOn}
                                        icons={false}
                                        onChange={toggleSwitch}
                                    />
                                </label>
                                <p style={{ fontSize: '13px' }} className="ml-2 color-[#090406]">Use same address for all products</p>
                            </div>
                        </div>
                        <div>
                            <div className="flex flex-wrap -mx-2.5 mt-2">
                                <div className="px-2.5 lg:w-1/2">
                                    <p className="mb-1.5 text-xs13 font-semibold text-[#808285]">Billing address</p>
                                    <div className="dropdown relative">
                                        <button onClick={() => handleToggle('billing_address')} type="button" id="s1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to text-left h-[108px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                            <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-1/2 right-5 " />
                                            {tempData.BILLING_ADDRESS.ADDRESS1}
                                            ,
                                            {tempData.BILLING_ADDRESS.ADDRESS2}
                                            ,
                                            {tempData.BILLING_ADDRESS.ADDRESS3}
                                            <br />
                                            {' '}
                                            {tempData.BILLING_ADDRESS.ADDRESS4}
                                            {' '}
                                            {tempData?.BILLING_ADDRESS.CITY}
                                            -
                                            {`${tempData.BILLING_ADDRESS.POSTAL_CODE}`}
                                            ,
                                            {' '}
                                            {tempData?.BILLING_ADDRESS.STATE}
                                            ,
                                            Location-
                                            {`${tempData.BILLING_ADDRESS.LOCATION ? tempData.BILLING_ADDRESS.LOCATION : ''}`}
                                            <br />
                                            GSTIN-
                                            {`${tempData.BILLING_ADDRESS.ATTRIBUTE2 ? tempData.BILLING_ADDRESS.ATTRIBUTE2 : ''}`}
                                        </button>
                                        {addressType.billing_address && (
                                            <ul className={`dropdown-menu w-full ${addressType.billing_address ? 'show' : 'hidden'}show absolute bg-[#FFFFFF] rounded-lg shadow-s2 py-3 overflow-auto pl-2 pr-3.5 max-h-[300px] scrollbar-menu z-10 relative`} aria-labelledby="s1">
                                                <input onChange={(e) => setsearchKey(e.target.value)} className="w-full border  h-8 p-3" placeholder="search address..." />
                                                {addressType.billing_address && addressDropdown.billing_address.length > 0 && addressDropdown.billing_address.filter((val) => handleSearch(val)).map((add, i) => (
                                                    <li key={i} className="w-full bg-[#ffffff] hover:bg-[#F5F5FA] rounded-md pl-1 py-1">
                                                        <div
                                                            className="relative flex items-center dropdown-item"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleAddressSelect(add, 'BILLING_ADDRESS');
                                                            }}
                                                        >
                                                            <input
                                                                type="radio"
                                                                id={`${add.CREATION_DATE}`}
                                                                name={add.unique_id}
                                                                checked={handleCheck(add, 'BILLING_ADDRESS')}
                                                                className="cursor-pointer"
                                                            />
                                                            <label htmlFor={`checkbox-${add.CREATION_DATE}`} className="text-sm font-normal text-[#555259] pl-5 cursor-pointer mt-[3px]">
                                                                {add?.ADDRESS1}
                                                                ,
                                                                {add?.ADDRESS2}
                                                                ,
                                                                {add?.ADDRESS3}
                                                                <br />
                                                                {' '}
                                                                {add?.ADDRESS4}
                                                                {' '}
                                                                {add?.CITY}
                                                                -
                                                                {`${add?.POSTAL_CODE}`}
                                                                ,
                                                                {' '}
                                                                {add?.STATE}
                                                                <br />
                                                                GSTIN-
                                                                {`${add?.ATTRIBUTE2}`}
                                                                <br />
                                                                Location-
                                                                {`${add?.LOCATION}`}
                                                            </label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                                <div className="px-2.5 lg:w-1/2 lg:mt-0 mt-3">
                                    <p className="mb-1.5 text-xs13 font-semibold text-[#808285]">Shipping address</p>
                                    <div className="dropdown relative">
                                        <button onClick={() => handleToggle('shipping_address')} type="button" id="s1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to text-left h-[108px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                            <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-1/2 right-5" />
                                            {tempData.SHIPPING_ADDRESS.ADDRESS1}
                                            ,
                                            {tempData.SHIPPING_ADDRESS.ADDRESS2}
                                            ,
                                            {tempData.SHIPPING_ADDRESS.ADDRESS3}
                                            <br />
                                            {' '}
                                            {tempData.SHIPPING_ADDRESS.ADDRESS4}
                                            {' '}
                                            {tempData.SHIPPING_ADDRESS.CITY}
                                            -
                                            {`${tempData.SHIPPING_ADDRESS.POSTAL_CODE}`}
                                            ,
                                            {' '}
                                            {tempData?.SHIPPING_ADDRESS.STATE}
                                            ,
                                            Location-
                                            {`${tempData.SHIPPING_ADDRESS.LOCATION ? tempData.SHIPPING_ADDRESS.LOCATION : ''}`}
                                            <br />
                                            GSTIN-
                                            {`${tempData.SHIPPING_ADDRESS.ATTRIBUTE2 ? tempData.SHIPPING_ADDRESS.ATTRIBUTE2 : ''}`}
                                        </button>
                                        {addressType.shipping_address && (
                                            <ul className={`dropdown-menu w-full ${addressType.shipping_address ? 'show' : 'hidden'}show absolute bg-[#FFFFFF] rounded-lg shadow-s2 py-3 overflow-auto pl-2 pr-3.5 max-h-[300px] scrollbar-menu z-10`} aria-labelledby="s1">
                                                <input onChange={(e) => setsearchKey(e.target.value)} className="w-full border  h-8 p-3" placeholder="search address..." />

                                                {addressType.shipping_address && addressDropdown.shipping_address.length > 0
                                            && addressDropdown.shipping_address.filter((val) => handleSearch(val)).map((add, i) => (
                                                <li key={i} className="w-full bg-[#ffffff] hover:bg-[#F5F5FA] rounded-md pl-2 py-1">
                                                    <div
                                                        className="relative flex items-center dropdown-item"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleAddressSelect(add, 'SHIPPING_ADDRESS');
                                                        }}
                                                    >
                                                        <input
                                                            type="radio"
                                                            id={`${add.unique_id}`}
                                                            name={add.unique_id}
                                                            checked={handleCheck(add, 'SHIPPING_ADDRESS')}
                                                            className="cursor-pointer"
                                                        />
                                                        <label htmlFor={`checkbox-${add.unique_id}`} className="text-sm font-normal text-[#555259] pl-5 cursor-pointer mt-[3px]">
                                                            {add?.ADDRESS1}
                                                            ,
                                                            {add?.ADDRESS2}
                                                            ,
                                                            {add?.ADDRESS3}
                                                            <br />
                                                            {' '}
                                                            {add?.ADDRESS4}
                                                            {' '}
                                                            {add?.CITY}
                                                            -
                                                            {`${add?.POSTAL_CODE}`}
                                                            ,
                                                            <br />
                                                            {' '}
                                                            {add?.STATE}
                                                            ,
                                                            Location-
                                                            {`${add?.LOCATION}`}
                                                            <br />
                                                            {' '}
                                                            GSTIN-
                                                            {`${add?.ATTRIBUTE2}`}
                                                        </label>
                                                    </div>
                                                </li>
                                            ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pt-[22px] flex justify-center">
                        <button onClick={() => handleConfirm()} type="button" className=" flex justify-center items-center sm:w-[306px] sm:py-3.5 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close">
                            {loading ? <ThreeDotsLoader /> : 'Confirm'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddressChangeModal;
